import { render } from "./FooterElement.vue?vue&type=template&id=aca64dd6&scoped=true"
import script from "./FooterElement.vue?vue&type=script&lang=js"
export * from "./FooterElement.vue?vue&type=script&lang=js"

import "./FooterElement.vue?vue&type=style&index=0&id=aca64dd6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca64dd6"]])

export default __exports__